import { Navigate, Outlet } from 'react-router-dom';

import DashboardLayout from './DashboardLayout';
import { useSession } from './SessionContext';

import Loading from '@/components/Loading/Loading';

type props = {
  isLogin: boolean;
};

export const PrivateLayout = ({ isLogin }: props) => {
  const { isConfigured } = useSession();

  // 認証の設定が完了するまでは何も表示しない
  if (!isConfigured) {
    return <Loading />;
  }

  return isLogin ? (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ) : (
    <Navigate to="/admin/login" />
  );
};
